var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('super-multi-section-list',{attrs:{"title":_vm.title,"multi-section-list":_vm.multiSectionList,"component-name":_vm.componentName,"close-fn":_vm.back}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }